<template>
  <a-card :bordered='false' :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs v-model:activeKey="search.out_warehousing_type" @change='pageSearchChange'>
      <a-tab-pane :key="1" tab="经销商"></a-tab-pane>
      <a-tab-pane :key="2" tab="门店"></a-tab-pane>
    </a-tabs>
    <a-form class="m-b-20" ref='form' :model='search'  :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword' style='margin-bottom: 10px;'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="sn">出库单号</a-select-option>
            <a-select-option value="product_name">商品名称</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="发货人信息" name='from_keyword'>
        <a-input style="width: 270px" v-model:value="search.from_keyword" placeholder="请输入发货人/发货人手机号进行搜索" />
      </a-form-item>
      <a-form-item label="收货人信息" name='to_keyword'>
        <a-input style="width: 270px" v-model:value="search.to_keyword" placeholder="请输入收货人/收货人手机号进行搜索" />
      </a-form-item>
      <a-form-item label="状态" name='out_warehousing_status'>
        <a-select v-model:value="search.out_warehousing_status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="2">已出货</a-select-option>
          <a-select-option :value="3">已签收</a-select-option>
          <a-select-option :value="4">订单关闭</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="出货单添加时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='out_warehousing_sn' :columns='columns' :data-source='data' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1'  >
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+item.product_image" alt=""
                  style="width:50px;height: 50px;object-fit:cover">
              </template>
              <template #description>   {{!item.product_sku_name || item.product_sku_name=='0' ? '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <div  v-for="(item,index) in record.product" :key='index'>
            <img class="m-r-10" :src="info.picdomain+'/'+(item.product_image)" v-if='index == 0' alt="" style="width:50px;height:50px">
          </div>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情</a-button>
        </div>
      </template>
      <template v-slot:from="{record}">
        <p>{{record.from}}</p>
        {{record.from_mobile}}
      </template>
      <template v-slot:to="{record}">
        <p>{{record.to}}</p>
        {{record.to_mobile}}
      </template>
      <template v-slot:real_num="{record}">
          <p @click="codeDetailVisible=true;targetId=record.out_warehousing_sn" style="color:#f04635;cursor: pointer;">{{record.out_warehousing_real_num || '-'}}</p>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="link" v-has:antiDocumentsChannelDetail="()=> {$router.push('/antiFleeingGoods/documents/channelDetails?id='+record.out_warehousing_sn)}">查看详情</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  
  <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
    <goodDetail  :listdata="targetList"/>
  </a-modal>
  <a-modal :keyboard="false" :maskClosable='false' v-model:visible="codeDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
      <codeDetail  :id="targetId"/>
  </a-modal>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import { getOutWarehousingChannelList } from "@/api/antiFleeing";
  import store from '@/store'
  import goodDetail from '../../components/goodDetails.vue'
     import codeDetail from './components/codeDetail'
  // 初始化默认筛选项数值
  let defSearch = {
    out_warehousing_type: 1,
    start_time: "",
    end_time: "",
    out_warehousing_status:'',
    page: 1,
    limit: 10,
    key_type: "sn",
    keyword: "",
    channel:1,
    from_keyword:'',
    to_keyword:''
  };
  export default {
    components: { goodDetail,codeDetail },
    setup() {
      // // 初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      // 列表数据和列头配置
      const data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        time: [],
        total: 0,
        goodDetailVisible:false,
        codeDetailVisible:false,
        targetId:""
      });
      let columns = [
        {
          title: "出库单号",
          dataIndex: "out_warehousing_sn",
          key: "out_warehousing_sn",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "发货经销商",
          dataIndex: "from",
          key: "from",
          slots: { customRender: "from" }
        },
        {
          title: "收货名称",
          dataIndex: "to",
          key: "to",
          slots: { customRender: "to" }
        },
         {
        title: "出库数量",
        dataIndex: "out_warehousing_num ",
        key: "out_warehousing_num ",
        slots: { customRender: "real_num" },
      },
        {
          title: "出库单类型",
          dataIndex: "is_allocation_text",
          key: "is_allocation_text",
        },
        {
          title: "状态",
          dataIndex: "out_warehousing_status_text",
          key: "out_warehousing_status_text",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "操作",
          key: "action",
          fixed: 'right',
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getOutWarehousingChannelList({...search.value}).then((res) => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.meta.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime
      };
    },
  };
</script>